import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Loader} from 'semantic-ui-react';
import {parseWarehouses} from '../../utils';
import FieldsHeader from './fieldsHeaders';
import LocationRow from './locationRow';

class fieldsSection extends Component {
  constructor(props) {
    super(props);
    this.renderFields = this.renderFields.bind(this);
  }

  renderFields(warehouses, zones) {
    const {locations} = this.props;

    return locations.map((item, index) => {
      return (
        <LocationRow
          key={index}
          warehouses={warehouses}
          zones={zones}
          location={item}
          index={index}
        />
      );
    });
  }

  render() {
    const {loadingWarehouses, loadingZones, warehouses, zones, permissions} = this.props;
    const filteredWarehouses = parseWarehouses(warehouses, permissions);

    if (loadingWarehouses || loadingZones) {
      return (
        <Card className='loading-card' raised fluid>
          <Loader active inline='centered'>Obteniendo Información...</Loader>
        </Card>
      );
    }

    return (
      <Card className='locations-fields' raised fluid>
        <FieldsHeader warehouses={filteredWarehouses} zones={zones} />
        <Grid>
          {this.renderFields(filteredWarehouses, zones)}
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loadingZones': state.zones.loading,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'zones': state.zones.list,
  };
};

export default connect(mapStateToProps)(fieldsSection);
